import React, { useState, useEffect } from "react";
import banner1 from "./digitalmenu.jpg";
import banner2 from "./digmenu.jpg";
import banner3 from "./digmenu1.jpg";
import banner4 from "./image.webp";
import banner5 from "./digmenu2.png";
import logo from "./maamaaslog.png"; // your logo image

const images = [banner1, banner2, banner3, banner4, banner5];

const BannerCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [textVisible, setTextVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setTextVisible(true), 500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="container-fluid" >
      <div className="row"><div className="col-lg-2"></div> <div className="col-lg-8 main-ladingpage">

        <div style={styles.container}>
          <div style={styles.sliderWrapper}>
            {/* 🔳 Overlay for better text visibility */}
            <div style={styles.overlay}></div>

            {/* 🔁 Images */}
            <div
              style={{
                ...styles.slider,
                transform: `translateX(-${currentIndex * 100}%)`,
              }}
            >
              {images.map((img, index) => (
                <img key={index} src={img} alt="banner" style={styles.image} />
              ))}
            </div>

            {/* 🔳 Logo at top-left */}
            <img src={logo} alt="logo" style={styles.logo} />

            {/* 🔳 Text Overlay */}
            <div
              style={{
                ...styles.textOverlay,
                transform: textVisible
                  ? "translate(-50%, -50%)"
                  : "translate(-50%, -60%)",
                opacity: textVisible ? 1 : 0,
                transition: "all 0.8s ease-in-out",
              }}
            >
              <h1 style={styles.title}>Maamaas House</h1>
              <p style={styles.subtitle}>Since 1997</p>
            </div>
          </div>
        </div>

      </div>
      </div>
    </div>

  );
};

const styles = {
  container: {
    width: "100%",

    height: "500px",
    padding: "10px",
  },
  sliderWrapper: {
    position: "relative",
    width: "100%",
    overflow: "hidden",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.4)", // 🔳 Dark semi-transparent layer
    zIndex: 2,
  },
  slider: {
    display: "flex",
    transition: "transform 0.8s ease-in-out",
  },
  image: {
    flexShrink: 0,
    width: "100%",
    height: "500px",
    objectFit: "cover",
  },
  textOverlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    color: "#fff",
    textAlign: "center",
    zIndex: 3, // Above overlay
    padding: "0 10px",
  },
  title: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    margin: 0,
    letterSpacing: "1px",
    textShadow: "2px 2px 6px rgba(0,0,0,0.7)",
  },
  subtitle: {
    fontSize: "1.2rem",
    marginTop: "5px",
    fontWeight: 300,
    textShadow: "1px 1px 3px rgba(0,0,0,0.5)",
  },
  logo: {
    position: "absolute",
    top: "15px",
    left: "20px",
    height: "50px",
    width: "auto",
    zIndex: 4,
    objectFit: "contain",
  },
};

export default BannerCarousel;

